import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Expression is required
  if (!properties.expression || properties.expression.trim() === '') {
    errors.push({
      key: 'expression',
      message: 'Transform expression is required',
    });
  }

  // Check for return statement
  if (properties.expression && !properties.expression.includes('return')) {
    errors.push({
      key: 'expression',
      message: 'Expression must include a return statement',
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
